import React from 'react';
import { Tooltip } from '@plerionhq/design-system';
import {
  ArrowsPointingInIcon,
  ArrowsPointingOutIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import type { PanelSize } from './types';

import { useTranslation } from 'react-i18next';

interface PanelControlsProps {
  panelSize: PanelSize;
  onPanelSizeChange: (size: PanelSize) => void;
  onClose: () => void;
}

export const PanelControls: React.FC<PanelControlsProps> = React.memo(
  ({ panelSize, onPanelSizeChange, onClose }: PanelControlsProps) => {
    const { t } = useTranslation('pleri/chat');
    return (
      <div className="flex items-center gap-1">
        <Tooltip
          label={
            panelSize === 'expanded' ? t('viewFullScreen') : t('exitFullScreen')
          }
        >
          <button
            onClick={() =>
              onPanelSizeChange(
                panelSize === 'expanded' ? 'fullscreen' : 'expanded',
              )
            }
            className="flex h-7 w-7 items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-500 dark:hover:bg-gray-800 dark:hover:text-gray-300"
          >
            {panelSize === 'expanded' ? (
              <ArrowsPointingOutIcon className="h-4 w-4" />
            ) : (
              <ArrowsPointingInIcon className="h-4 w-4" />
            )}
          </button>
        </Tooltip>
        <Tooltip label={t('closeToolPanel')}>
          <button
            onClick={onClose}
            className="flex h-7 w-7 items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-500 dark:hover:bg-gray-800 dark:hover:text-gray-300"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </Tooltip>
      </div>
    );
  },
);

PanelControls.displayName = 'PanelControls';
